// External Dependencies
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ChatSupport from './Teacher/ChatSupport';
// Internal Dependencies
import { RoutesBuilder } from '../routes/index';
import Notifications from './Global/Notifications';
import EmailCaptureModal from './Teacher/EmailCaptureModal';
import { UserType } from '@/enums';
import STUDENT_ROUTES from '@/routes/STUDENT';
import TEACHER_ROUTES from '@/routes/TEACHER';
import SCHOOL_ADMIN_ROUTES from '@/routes/SCHOOL_ADMIN';
import DISTRICT_ADMIN_ROUTES from '@/routes/DISTRICT_ADMIN';
import { AmiraMessageProvider } from './Global/AmiraMessage/AmiraMessageContext';
// IRIPDocumentGenerator provides IRIP generation functionality triggered by events from other components
import IRIPDocumentGenerator from './Reports/containers/IRIP/IRIPDocumentGenerator';

type UserInfo = {
  userId: string | null;
  sessionId: string | null;
  userAgent: string | null;
  sessionStartTime: string | null;
  userType: UserType | null;
  partner: string;
  branding: string;
}

const App = ({userData}: {userData: UserInfo}) => {
  const [ modal ] = useState(null);
  const [ ready ] = useState(true);
  const { userType, partner, branding } = userData;
  const location = useLocation();
  const { routes, DEFAULT } =
    userType === UserType.TEACHER
      ? TEACHER_ROUTES
      : userType === UserType.SCHOOL_ADMIN
      ? SCHOOL_ADMIN_ROUTES
      : userType === UserType.DISTRICT_ADMIN
      ? DISTRICT_ADMIN_ROUTES
      : STUDENT_ROUTES;
  const pageClass = `page-${location.pathname
    .split("/")
    .filter(Boolean) // Remove empty segments
    .pop() || "home"}`; // Default to "home" if empty
  
  return (
    <AmiraMessageProvider>
      <main id="main" className={`page ${pageClass}`}>
        {modal}
        {ready && <RoutesBuilder routes={routes} DEFAULT={DEFAULT} />}
        {userType !== UserType.STUDENT && (!branding || branding.toUpperCase() !== "EPS") && <ChatSupport />}
        {userType === UserType.TEACHER && partner !== "HMH" && <EmailCaptureModal />}
        <Notifications filterDuplicates />
        
        {/* IRIPDocumentGenerator listens for events from other components like the instruct widget */}
        {userType === UserType.TEACHER && <IRIPDocumentGenerator />}
      </main>
    </AmiraMessageProvider>
  );
};

export default React.memo(App);
